import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { relayStylePagination } from '@apollo/client/utilities';
import { Hub } from 'aws-amplify/utils';
import { getIdToken } from '@sandtech-hub-monorepo/ui-auth-kit';

const httpLink = createHttpLink({
  uri: process.env['NX_GRAPHQL_API'],
});

const authMiddleware = setContext(async (_, { headers }) => {
  const idToken = await getIdToken();

  return {
    headers: {
      ...headers,
      ...(idToken ? { authorization: idToken } : {}),
    },
  };
});

export const client = new ApolloClient({
  link: from([authMiddleware, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      User: {
        keyFields: ['sandId'],
        fields: {
          notifications: relayStylePagination(),
        },
      },
      OnboardingPanel: {
        keyFields: ['sandId'],
      },
    },
  }),
});

Hub.listen('auth', (message) => {
  if (message.payload.event === 'signedOut') {
    client.resetStore();
  }
});
